


























































































































































import { Vue, Component, Ref } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';

@Component
export default class ReturnForm extends Vue {
    [x: string]: any;
    private boardMailStart = 'bal.customerservice';
    private boardMailEnd = '.board@ticketeer.se';
    public issueType: string = '';
    public orderNumber: string = '';
    public customerMail: string = '';
    private customerName: string = '';
    public message: string = '';
    public issueReceived: boolean = false;
    public files: any = null;
    public createTaskError: boolean = false;
    public getOrderError: boolean = false;
    public orderFound: boolean = false;
    private orderData: any = null;
    private moreThanOneOfProduct: any[] = [];
    public translations: any = window.__litium.translation;
    private checkBoxes: Array<string> = [
        'Returtransport bokad till Autoporten',
        'Retur ankomstkontrollerad på Autoporten',
        'Återbetald på Klarna',
        'Transport bokad till Returkompaniet',
        'Fakturerat Returkompaniet'
    ];
    private maxFilesSize: number = 20000000;
    get taskTitle(): string {
        if (this.orderNumberValid && this.mailValid) {
            switch (this.issueType) {
                case 'return':
                    return 'Retur - Order ' + this.orderNumber + ' - ' + this.customerMail;
                case 'complaint':
                    return 'Klagomål - Order ' + this.orderNumber + ' - ' + this.customerMail;
                default:
                    return '';
            }
        }
        return '';
    }

    get taskDescription(): string {
        let desc = 'Ordernummer: ' + this.orderNumber + '\n';
        if (this.orderData !== null) {
            desc += 'Länk till order: ' + this.orderData.link + '\n';
            desc += 'Namn: ' + this.orderData.firstName + ' ' + this.orderData.lastName + '\n';
            desc += 'Tel: ' + this.orderData.phone + '\n';
        }
        desc += 'E-post: ' + this.customerMail + '\n';
        if (this.productIssueList.length > 0) {
            desc += '\n*Berörda produkt(er)*\n';
            this.productIssueList.forEach(val => {
                if (val.quantity > 0) {
                    desc += '- ' + val.articleNumberNav + ' (' + val.quantity + '/' + val.ofQuantity + ')' + '\n';
                }
            });
        }
        desc += '\n*Beskrivning*\n';
        desc += this.message;
        return desc;
    }

    get orderNumberValid(): boolean {
        return /LS\d{6,7}$/i.test(this.orderNumber);
    }

    get mailValid(): boolean {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/i.test(this.customerMail);
    }

    get filesSelected(): boolean {
        return this.files !== null && this.files.length > 0;
    }

    get fileSizeOk(): boolean {
        return this.totalFileSize < this.maxFilesSize;
    }

    get messageValid(): boolean {
        return this.message.length >= 20;
    }

    get productOptions(): TextValuePair[] {
        if (this.orderData !== null) {
            const returnArray = [] as TextValuePair[];
            this.orderData.orderRows.forEach((row: any) => {
                returnArray.push({
                    text: row.name,
                    value: row.articleNumberNav
                });
            });
            return returnArray;
        } else {
            return [] as TextValuePair[];
        }
    }

    get hasSelectedProduct(): boolean {
        if (this.moreThanOneOfProduct.filter(x => x.quantity > 0).length < 1) {
            return false;
        }

        return true;
    }
    get formComplete(): boolean {
        if (this.moreThanOneOfProduct.filter(x => x.quantity > 0).length < 1) {
            return false;
        }
        if (!this.fileSizeOk) {
            return false;
        }
        if (!this.messageValid || (this.issueType === 'complaint' && !this.filesSelected)) {
            return false;
        }
        return true;
    }

    get productIssueList(): Array<any> {
        this.moreThanOneOfProduct = (this.orderData.orderRows as Array<any>).map(x => {
            return { ...x, ofQuantity: x.quantity, quantity: 0 };
        });

        return this.moreThanOneOfProduct;
    }

    get totalFileSize(): number {
        let totalSize = 0;
        if (this.files !== null) {
            for (let i = 0; i < this.files.length; i++) {
                totalSize += this.files[i].size;
            }
            return totalSize;
        }
        return 0;
    }

    public decrease(obj: any) {
        if (obj.quantity > 0) obj.quantity -= 1;
    }

    public increase(obj: any): void {
        if (obj.ofQuantity > obj.quantity) obj.quantity += 1;
    }

    public updateFiles(e: Event) {
        this.files = (e.target as HTMLInputElement).files;
    }

    public async getOrder() {
        // this.orderFound = true
        const settings = {
            method: 'GET'
        };
        try {
            const fetchResponse = await fetch(
                '/api/returnform?orderId=' + this.orderNumber + '&email=' + this.customerMail,
                settings
            );
            const data = await fetchResponse.json();
            if (!fetchResponse.ok) {
                this.getOrderError = true;
                throw new Error('Failed to fetch order');
            } else {
                console.log(data);
                this.orderData = data;
                this.orderFound = true;
            }
            return data;
        } catch (e) {
            return e;
        }
    }

    get jsonboxes(): string {
        return JSON.stringify(this.checkBoxes);
    }

    get boardMail(): string {
        return this.boardMailStart + this.boardMailEnd;
    }

    public async submitIssue() {
        if (this.formComplete) {
            this.createTaskError = false;
            let form = new FormData();
            form.append('message', this.taskDescription);
            form.append('subject', this.taskTitle);
            form.append('toMail', this.boardMail);
            form.append('fromMail', this.customerMail);
            form.append('checkBoxes', this.checkBoxes.join(','));
            if (this.files !== null) {
                Array.from(Array(this.files.length).keys()).map(x => {
                    form.append('file[]', this.files[x], this.files[x].name);
                });
                // form.append('file[]', this.files[0])
            }
            const settings = {
                method: 'POST',
                body: form
            };
            try {
                const fetchResponse = await fetch('https://api.ticketeer.se/mailbox', settings);
                const data = await fetchResponse.json();
                if (!fetchResponse.ok) {
                    this.createTaskError = true;
                    throw new Error('Failed creating task');
                }
                this.issueReceived = true;
                return data;
            } catch (e) {
                return e;
            }
        }
    }
}
